import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background-color: ${({ theme: { colors } }) => colors.general.WHITE};
  padding: ${({ theme: { units } }) => units.spacing.SMALL};
  border-radius: ${({ theme: { units } }) => units.sizes.BORDER_RADIUS};
  border: solid 1px ${({ theme: { colors } }) => colors.general.SOFT_GRAY};
`;

interface CardProps {
  children: any,
  className: string,
}

function Card ({
  className, children,
}: CardProps) {
  return (
    <CardContainer className={`${className}`}>
      { children }
    </CardContainer>
  );
}

export default Card;

Card.defaultProps = {
  children: null,
  className: '',
}
